import cn from 'classnames';
import type { ButtonHTMLAttributes} from 'react';
import type React from 'react';
import { useState } from 'react';

import type { Group } from '@shared/types/common';

import styles from './styles.module.scss';

interface ToggleProps extends ButtonHTMLAttributes<HTMLButtonElement> {
	// initial: boolean;
	// onToggle: (state: boolean) => void;
	group: Group;

	removeFromSelectedGroups: (group: Group) => void;
	addSelectedToGroups: (group: Group) => void;
	isSelectedAtAnyGroups: (group: Group) => boolean;
}

export const Toggle: React.FC<ToggleProps> = ({
	isSelectedAtAnyGroups,
	group,
	removeFromSelectedGroups,
	addSelectedToGroups,
}) => {

	const onToggle = () => {
		isSelectedAtAnyGroups(group) ? removeFromSelectedGroups(group) : addSelectedToGroups(group);
	};

	return (
		<button
			// {...props}
			className={cn(styles.toggle, {
				[styles.on]: isSelectedAtAnyGroups(group),
				[styles.off]: !isSelectedAtAnyGroups(group),
			})}
			onClick={() => onToggle()}
			type="button"
		>
			<div className={styles.toggle__circle} />
		</button>
	);
};
